import React from 'react';
import Modal from 'react-bootstrap/Modal'
import {useDispatch, useSelector} from "react-redux";
import {deleteProduct, setDeleteProductId} from "../../actions/product";

const ProductDeleteForm = () => {

    const dispatch = useDispatch();

    const {delete_product, currentPage, numberOfPages, products} = useSelector(state => state.product);

    const closeModal = () =>{
        // removing product from redux state by sending null setDeleteProductId
        dispatch(setDeleteProductId(null))
    };

    let getPage = null;

    const onConfirm = () =>{

        if ((currentPage == numberOfPages) && (products.length == 1) ){
            getPage = (currentPage - 1);
        }
        else{
            getPage = currentPage;
        }
        dispatch(deleteProduct(delete_product.id, getPage))
    };

    let condition = false;
    if(delete_product !== null)
        condition = true;

    return (
        <div>
            <Modal show={condition} onHide={closeModal}>
                <Modal.Header className="bg-danger" closeButton>
                    <Modal.Title className="text-white" >Mahsulotni o'chirish</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Siz haqiqatdan ham ushbu mahsulotni o'chirmoqchimisiz ?
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={closeModal} className="btn btn-secondary">YO'Q</button>
                    <button onClick={onConfirm} className="btn btn-primary">HA</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ProductDeleteForm;